var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.1,2.5H5.9V0H4.1v2.5H0v20h20v-20h-4.1V0h-1.9V2.5z M1.9,4.4 h16.3v3.8H1.9V4.4z M1.9,10v10.6h16.3V10H1.9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }